module.exports = __webpack_public_path__ + "img/google.78f0444b.svg";